import { render, staticRenderFns } from "./MergeLayout.vue?vue&type=template&id=a2a8389a"
import script from "./MergeLayout.vue?vue&type=script&lang=js"
export * from "./MergeLayout.vue?vue&type=script&lang=js"
import style0 from "./MergeLayout.vue?vue&type=style&index=0&id=a2a8389a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports